import { FlowType } from '@app/hooks/useSteps'

export const TRACKING_FLOW_TYPE: Record<FlowType, string> = {
  EMAIL: 'invitation_by_email',
  MAIL: 'invitation_by_mail',
  CARD: 'invitation_by_card',
}
export const TRACKING_STEP: Record<string, string> = {
  IDENTITY: 'identity',
  MISSING_DATA: 'missing_data',
  PASSWORD: 'password',
  PHONE_NUMBER: 'phone_number',
  OTP: 'otp',
  IDENTITY_CHOICE: 'identity_choice',
  IDENTITY_VERIFICATION: 'identity_verification',
  EMAIL_LOGIN: 'email_login',
  CONFIRMATION: 'confirmation',
}

export const trackPage = (_page: string, _args?: unknown): void => undefined
